import http from "./http-common";
import authHeader from "./auth-header";
import process from "shelljs";

const API_URL = process.env.BFF_URL;

class CurrencyService {

  findAll() {
    return http.get(API_URL + "/currencies", { headers: authHeader() })
  }

  findCurrencies( params) {
    return http.get(API_URL + "/currencies", { params: params, headers: authHeader() });
  }
  create(user) {
    return http.post(API_URL + "/currencies", user, { headers: authHeader() });
  }

  update(id, user) {
    return http.put(API_URL + `/currencies/${id}`, user, { headers: authHeader() });
  }

  findById(id) {
    return http.get(API_URL + `/currencies/${id}`, { headers: authHeader() });
  }

  delete(id) {
    return http.delete(API_URL + `/currencies/${id}`, { headers: authHeader() });
  }

  createCurrencyRate(data) {
    return http.post(API_URL + "/currency-rate", data, { headers: authHeader() });
  }

  setDefaultCurrencyRate(id, data) {
    return http.put(API_URL + `/app/currency-rates/${id}/set-default`, data, { headers: authHeader() });
  }

  convert(params) {
    return http.get(API_URL + "/app/currency-rates/convert", { params: params, headers: authHeader() })
  }

  updateCurrencyRate(id, data) {
    return http.put(API_URL + `/currency-rate/${id}`, data, { headers: authHeader() });
  }

  findCurrencyRate(from, to, storeId, page, size) {
    return http.get(API_URL + "/currency-rate?from=" + from + "&to="+ to + "&storeId="+ storeId +"&page=" + page + "&size=" + size, { headers: authHeader() })
  }

  findCurrencyRates(storeId, page, size) {
    return http.get(API_URL + "/currency-rate?storeId=" + storeId +"&page=" + page + "&size=" + size, { headers: authHeader() })
  }

  deleteCurrencyRate(id) {
    return http.delete(API_URL + `/currency-rate/${id}`, { headers: authHeader() });
  }

  handleResponse(response) {
    return response
  }
}

export default new CurrencyService();



// WEBPACK FOOTER //
// ./src/service/currency.service.js